<template>
  <div class="wrapper-page">
    <img v-show="!loading" alt="logo" src="../../assets/logo-blue.svg" width="475">
    <loading v-if="loading" class="centered"/>
    <div v-else class="app-login invitation-login">
      <section>
        <div>
          <h4>{{ $t('msoffice.relatico_for_outlook') }}</h4>

          <div v-if="loggedIn" class="text-center">
            <h5>{{ $t('msoffice.you_are_logged') }}:</h5>
            <div class="row user-image-row">
              <div class="col-12">
                <user-image :user='currentUser'/>
              </div>
            </div>
            <div class="row">
              <div class="col-12"><strong>{{ $t('msoffice.full_name') }}</strong></div>
              <div class="col-12">{{ currentUser.full_name }}</div>
              <div class="col-12"><strong>{{ $t('login.email') }}</strong></div>
              <div class="col-12">{{ currentUser.email }}</div>
              <div class="col-12 text-center mt-3">
                <a href="#" @click.prevent="switchLogin=true">{{ $t('msoffice.switch_account') }}</a>
              </div>
            </div>
          </div>
          <div v-else class="text-center">
            <h5>{{ $t('login.header') }}</h5>
            <form class="new_session" @submit.stop.prevent="login()">
              <div class="form-group">
                <input v-model="email" class="form-control" placeholder=" " autocomplete="on" required="required" type="email">
                <label>{{ $t('login.email') }}</label>
              </div>
              <div class="form-group">
                <input v-model="pass" class="form-control" placeholder=" " required="required" type="password">
                <label>{{ $t('login.password') }}</label>
              </div>
              <div class="form-group text-center row">
                <div class="col-12">
                  <button class="btn btn-primary btn-login" :disabled="isProcessing" :data-disable-with="$t('login.header')" type="submit">
                    {{ $t('login.header') }}
                    <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <h6>{{ $t('msoffice.permission.able_to') }}:</h6>
                <div class="col-12">{{ $t('msoffice.permission.save_attach') }}</div>
                <div class="col-12">{{ $t('msoffice.permission.read_write') }}</div>
                <div class="col-12">{{ $t('msoffice.permission.manage_checklists') }}</div>
                <div class="col-12">{{ $t('msoffice.permission.share_unshare_files') }}</div>
            </div>
            <div class="col-12 mt-4" v-show="loggedIn">
              <button class="mr-2 btn btn btn-neutral"
              @click.prevent="close()">
                {{ $t('msoffice.deny') }}
              </button>
              <button class="btn btn btn-primary"
              @click.prevent="login()" :disabled="isProcessing">
                {{ $t('msoffice.allow') }}
                <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _user_image from '@/components/_user_image'
import _loading from '@/components/_loading'

export default {
  name: "MsOfficeLogin",
  components: {
    'user-image': _user_image,
    loading: _loading
  },
  data: () => {
    return {
      email: '',
      pass: '',
      ready: false,
      loading: true,
      switchLogin: false,
      isProcessing: false,
      idToken: null
    }
  },
  watch: {
    ready(status) {
      if (status)
        this.startUp()
    }
  },
  mounted() {
    this.officeStore.getOfficeApi().then(() => {
      this.ready = true
    }).catch(() => {
      this.loading = false
    })
  },
  computed: {
    office() {
      return window.Office.context
    },
    platform() {
      return this.office.diagnostics.platform || ''
    },
    loggedIn(){
      return (Object.entries(this.currentUser).length > 0 && this.switchLogin === false)
    },
    roaming() {
      return this.office.roamingSettings
    }
  },
  methods: {
    startUp() {
      this.idToken = this.getStorage('id_token')

      this.store.sendMetrics({name: 'msoffice_addin_open_login_dialog', params: this.$route.params, path: this.$route.fullPath})

      this.store.getCurrentUser().finally(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    login() {
      this.store.sendMetrics({name: 'msoffice_addin_submit_login_dialog', params: {email: this.email}, path: this.$route.fullPath})
      this.isProcessing = true

      this.officeStore.login(this.email, this.pass, this.idToken, this.platform).then((data) => {
          this.messageParent('success', data)
      }).catch(() => {
          this.isProcessing = false
          this.$toastr.alert(this.$t('flash_messages.login_invalid'))
      })
    },
    getStorage(key) {
      let k = window.btoa('rel_'+key)
      let roam = this.roaming.get(k) || null
      let storage = window.localStorage.getItem(k) || null

      if(roam)
        return roam
      return storage
    },
    messageParent(status, data){
      this.office.ui.messageParent(JSON.stringify({status: status, result: data}))
    },
    close(){
      window.close()
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../styles/account-pages.sass"
.user-image-row
  display: inline-flex
.user-image-wrapper
  margin: 0
.btn-login
  border: solid 1px #d2d2d2
  position: relative
  top: 0
  left: 0
  z-index: 1
  padding: 12px 12px 12px 12px
  font-family: 'Roboto', sans-serif
  margin-top: 10px
  min-width: 190px
.centered
  position: fixed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
.loading-spinner
  margin: 0
.btn-login
  border: solid 1px #d2d2d2
  transition: border-color .25s ease-in-out, box-shadow .25s ease-in-out
  &:hover
    border: solid 1px #58a3da
    transition: border-color .25s ease-in-out, box-shadow .25s ease-in-out
</style>
